import { render, staticRenderFns } from "./ProblemParcel.vue?vue&type=template&id=9aadd098&scoped=true"
import script from "./ProblemParcel.vue?vue&type=script&lang=js"
export * from "./ProblemParcel.vue?vue&type=script&lang=js"
import style0 from "./ProblemParcel.vue?vue&type=style&index=0&id=9aadd098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aadd098",
  null
  
)

export default component.exports